<template>
  <div id="app">
    <div id="body-tag" class="background-img"
         :style="{ backgroundImage: 'url(' + require(`./assets/${backgroundImageUrl}.png`) + ')' }">
    </div>
    <nav class="navbar">
      <div class="row no-gutters align-items-center justify-content-start">
        <img class="mr-2 mr-md-5" src="./assets/vodacom-icon.png" style="height: 90%;"/>
        <h5>Terms & Conditions</h5>
      </div>
      <GoBack v-if="miniAppModel.miniAppMode" v-bind:miniAppModel="miniAppModel"/>
    </nav>
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 overlay text-white">
        <p class="row justify-content-center main-heading">
          <strong class="sub-heading">FANTASY DRIBBLE TERMS AND CONDITIONS</strong>
        </p>
        <hr>
        <p>
          1. These terms and conditions govern the relationship between You (“You” or “Your”) and Vodacom Proprietary
          Limited and its affiliates (hereinafter “Vodacom” or “Us” or “We”) and Fanclash South Africa Proprietary
          Limited regarding Your use of the Fantasy Dribble Service (the “Service”) (“Terms and Conditions”). Use of the
          Service is also governed by the <a href="https://www.vodacom.co.za/vodacom/privacy-policy/fantasy-league"
                                             target="_blank">
          <strong>Privacy Policy</strong></a> which is incorporated herein by reference.
        </p>

        <div class="accordion" id="accordionExample">
          <div class="card">
            <div class="card-header" id="headingOne">
              <h2 class="mb-0 collapsed" data-toggle="collapse"
                  data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                <button class="btn btn-link" type="button">
                  YOUR ACCEPTANCE OF THESE TERMS AND CONDITIONS
                </button>
              </h2>
            </div>
            <hr>
            <div id="collapseOne" class="collapse" aria-labelledby="headingOne"
                 data-parent="#accordionExample">
              <div class="card-body">
                <p>
                  2. PLEASE READ THESE TERMS AND CONDITIONS AND THE <a
                    href="https://www.vodacom.co.za/vodacom/privacy-policy/fantasy-league" target="_blank">
                  <strong>Privacy Policy</strong></a> CAREFULLY BEFORE USING THE SERVICE OR SUBMITTING INFORMATION
                  THROUGH THE SERVICE. BY USING THE SERVICE OR SUBMITTING INFORMATION THROUGH THE SERVICE, YOU ARE
                  AGREEING TO THESE TERMS AND CONDITIONS. IF YOU DO NOT AGREE, PLEASE DO NOT USE THIS SERVICE OR SUBMIT
                  ANY INFORMATION THROUGH THE SERVICE. WE RESERVE THE RIGHT, AT ANY TIME, TO MODIFY AND UPDATE THESE
                  TERMS AND CONDITIONS FROM TIME TO TIME BY POSTING SUCH UPDATED TERMS AND CONDITIONS ON THE VODACOM
                  WEBSITE. ANY SUCH UPDATES SHALL APPLY TO YOU AND YOUR USE OF THE SERVICE AND BY CONTINUING TO USE THE
                  SERVICE, YOU SHALL BE DEEMED TO HAVE ACCEPTED SUCH CHANGES.
                </p>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h2 class="mb-0 collapsed" data-toggle="collapse"
                  data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                <button class="btn btn-link" type="button">
                  HOW TO SUBSCRIBE OR UNSUBSCRIBE TO THE SERVICE?
                </button>
              </h2>
            </div>
            <hr>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                 data-parent="#accordionExample">
              <div class="card-body">
                <p>2.1) In order to subscribe the Service, You must:</p>
                <p><span class="pl-3">2.1.1) dial USSD: *130*2586#; or</span></p>
                <p><span class="pl-3">2.1.2) visit Web: fantasydribble.com.</span></p>
                <p>2.2) You are entitled to unsubscribe from the Service at any time and for any reason by following the
                  “cancel” prompts available within the Service menu, or by:</p>
                <p><span class="pl-3">2.2.1) using Vodacom self-service channels;</span></p>
                <p><span class="pl-3">2.2.2) calling Vodacom Customer Care: 082 135;</span></p>
                <p><span class="pl-3">2.2.3) dial USSD: *130*2586#;</span></p>
                <p><span class="pl-3">2.2.4) visit WEB: fantasydribble.com</span></p>
                <p><span class="pl-3">2.2.5) dial USSD: *135*997# (Vodacom Global Opt Out); or</span></p>
                <p><span class="pl-3">2.2.6) viewing Content Services on the Vodapay App.</span></p>
                <p>2.3) When cancelling/ unsubscribing from the Service, You accept that Your old profile and preferences
                  will be retained for a 6 (six) month period and for no longer than 5 (five) years (only if
                  necessary), in order to facilitate a convenient experience should You choose to re-subscribe at a later
                  stage within the 6 (six) month period.</p>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingThree">
              <h2 class="mb-0 collapsed" data-toggle="collapse"
                  data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                <button class="btn btn-link" type="button">
                  GENERAL
                </button>
              </h2>
            </div>
            <hr>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                 data-parent="#accordionExample">
              <div class="card-body">
                <p>2.4) As a user of the Service, You will have the option to subscribe on a once off basis or a
                  reoccurring basis, with either option making You a paying user and doing so accordingly binds You to
                  these Terms and Conditions. As a subscribed user, You will be asked to submit personal information to
                  us. We are committed to ensuring responsible practices in the collection, use and disclosure of Your
                  personal information in accordance with applicable law and the Privacy Policy incorporated by reference
                  into and form a binding part of these Terms and Conditions.</p>
                <p>2.5) By subscribing to the Service, You agree to the following additional rules upon successful initial
                  registration for the Service:</p>
                <p><span class="pl-3">2.5.1) You will be eligible to access all the content on the Service free of charge for 1 (one) day (the “Free Trial Day”). For the avoidance of doubt, You will not be eligible for another Free Trial Day if You cancel Your subscription and then re-register at a later stage.</span>
                </p>
                <p><span class="pl-3">2.5.2) After the Free Trial Day, You will be charged a subscription fee of ZAR 5 (five Rand) per day (incl. VAT) (the “Fee”) for the relevant period that You remain subscribed for the Service.</span>
                </p>
                <p>2.6) If You are a pre-paid or top-up user:</p>
                <p><span class="pl-3">2.6.1) the Fee will be deducted from Your available airtime balance depending on the subscription that you have chosen. You acknowledge that You must have enough airtime available to pay the Fee to continue to use the Service;</span>
                </p>
                <p><span class="pl-3">2.6.2) if You fail to satisfy Your Fee obligation for 30 (thirty) consecutive days after the last successful Fee was collected, Vodacom may at its sole discretion suspend or terminate Your subscription to the Service;</span>
                </p>
                <p><span class="pl-3">2.6.3) the Fee for each day of the month that You were subscribed to the Service for will be set out in Your monthly statement for payment. If You do not pay Your monthly Fee set out in Your monthly statement, Your subscription may be suspended;</span>
                </p>
                <p><span class="pl-3">2.6.4) before the expiry of the Free Trial Day, You may cancel Your subscription to the Service to avoid being charged the Fee.</span>
                </p>
                <p><span class="pl-3">2.6.5) only one subscription is permitted per mobile number. Vodacom and non-Vodacom (where they can do so) users within the Republic of South Africa may subscribe.</span>
                </p>
                <p>2.7) If You are a contract user, the Fee will be set out in Your monthly statement. If You do not pay
                  Your monthly Fee, Your subscription may be suspended by Vodacom in its discretion.</p>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingMicroBilling">
              <h2 class="mb-0 collapsed" data-toggle="collapse"
                  data-target="#collapseMicroBilling" aria-expanded="false" aria-controls="collapseMicroBilling">
                <button class="btn btn-link" type="button">
                  MICRO-BILLING & MESSAGING
                </button>
              </h2>
            </div>
            <hr>
            <div id="collapseMicroBilling" class="collapse" aria-labelledby="headingMicroBilling"
                 data-parent="#accordionExample">
              <div class="card-body">
                <p>2.8) If Vodacom are unable to bill the full value of the subscription You have chosen for the Service,
                  we may implement micro-billing. Micro billing occurs when You have subscribed to Service and You do not
                  have sufficient funds in Your account (i.e., Your airtime balance) to pay for the subscription that
                  You have chosen. Micro-billing will allow Vodacom to charge a discounted subscription or any reduced
                  amount as we may determine from time to time dependent on the available balance until we can charge
                  You the full amount. If we are successful in billing an amount, in part of in full for the end of the
                  applicable period (depending on the subscription chosen), that billing record will stand as the
                  completed billing for that particular period. Billing for the next period will revert back to
                  attempting to bill the full stated price. Billing does not occur in arrears. Micro-billing shall be
                  implemented in Vodacom’s sole and absolute discretion. You must have enough airtime available for
                  payment of the subscription You have chosen for the Service to keep Your subscription in an active
                  state. You acknowledge that in the event we are unable to bill any valid value for Your subscription
                  of the Service that You have chosen, we will continue to attempt to bill and enable the subscription
                  for a maximum period of 30 (thirty)consecutive days after the last successful bill collected. Should we
                  be unable to collect any funds for a period of 30 (thirty) consecutive days, You will be automatically
                  unsubscribed from the Service.</p>
                <p>2.9) You give us consent to provide You with various messages about / based on Your interaction with
                  the Service. These messages will be delivered to You in the form of text messages sent to Your mobile
                  device using the mobile number identifying You as a user of the Service.</p>
                <p>2.10) These messages include, but are not limited to:</p>
                <p><span class="pl-3">2.10.1) periodic messages to encourage, or remind You to browse or access the Service;</span>
                </p>
                <p><span class="pl-3">2.10.2) messages inviting You to share, voluntarily, data about Yourself or Your preferences;</span>
                </p>
                <p><span class="pl-3">2.10.3) messages inviting You to try alternate versions of the Service based on Vodacom’s knowledge of the device You are using to access the Service;</span>
                </p>
                <p><span class="pl-3">2.10.4) confirmation messages relating to Your subscribing for, or cancellation of, the Service;</span>
                </p>
                <p><span class="pl-3">2.10.5) messages inviting You to rate the Service’s quality and Your opinion of Your experience of the Service as measured by the metric scale provided;</span>
                </p>
                <p><span class="pl-3">2.10.6) messages with Service content, including, but not limited to, confirmation of weekly results/ draws/ picks, and;</span>
                </p>
                <p><span class="pl-3">2.10.7) messages relating to the earning, notification, and servicing of rewards.</span></p>
                <p>2.11) You may opt out of the messages above except for the system messages which are mandatory in
                  order for us to correctly administrate Your use of the Service. To opt out of the messages, You are
                  advised to make use of the functionality on the Service settings to cancel messages, or alternatively,
                  to send an opt-out message request to SMS STOP To 30881 or dial *135*18.</p>
                <p>2.12) You will not be charged for interactions that You will have with the Service via SMS. Data
                  charges may apply for accessing the Service on website.</p>
                <p>2.13) You accept that the Service’s default language is English.</p>
                <p>2.14) By subscribing, You agree that You will be opted into receiving the messages mentioned above,
                  which You may cancel at any time via the Service menu.</p>
                <p>2.15) You acknowledge that Your subscription information will be retained for use to allow You access
                  to future iterations and new features of the Service, and that You will be engaged to continue using
                  the Service as applicable for other functionality intended to be covered by the Service.</p>
                <p>2.16) You acknowledge that any subscriptions in error will be billed. For Your protection, we ask You
                  to confirm all purchases twice.</p>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingFour">
              <h2 class="mb-0 collapsed" data-toggle="collapse"
                  data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                <button class="btn btn-link" type="button">
                  REWARDS & PRIZES (WHERE APPLICABLE)
                </button>
              </h2>
            </div>
            <hr>
            <div id="collapseFour" class="collapse" aria-labelledby="headingFour"
                 data-parent="#accordionExample">
              <div class="card-body">
                <p>2.17) If applicable and to be eligible for rewards from the Service, You acknowledge that You need to
                  have an active subscription for the Service.</p>
                <p>2.18) You acknowledge, understand, and agree that for Your subscription to the Service does not
                  guarantee any prizes or rewards from the Service. We shall not have any liability for such loss or
                  damage while using the Service.</p>
                <p>2.19) Where applicable, prizes may not be substituted or transferred. All taxes associated with the
                  receipt or use of any prize is the sole responsibility of the winner. If any legal authority contests
                  the awarding of a prize, we may, in our sole discretion, determine whether or not to award such a
                  prize.</p>
                <p>2.20) Rewards can only be earned if You are a Vodacom customer. Any non-Vodacom customers will be
                  unable to earn rewards due to their being active on a different network.</p>
                <p>2.21) Only the qualifying Vodacom mobile number that is subscribed to the Service, can earn rewards.
                </p>
                <p>2.22) In the event that You terminate Your Vodacom contract, You accept that You forfeit the use of any
                  unused rewards by that point as well as the earning of future rewards from that point.</p>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingFive">
              <h2 class="mb-0 collapsed" data-toggle="collapse"
                  data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                <button class="btn btn-link" type="button">
                  GAME RULES
                </button>
              </h2>
            </div>
            <hr>
            <div id="collapseFive" class="collapse" aria-labelledby="headingFive"
                 data-parent="#accordionExample">
              <div class="card-body">
                <p>2.23) Fantasy Dribble games are games of skill and require some skill and knowledge of professional
                  sports information as well as our rules for You to accumulate fantasy points.</p>
                <p>2.24) Fantasy points are accumulated through the performance of real-life athletes across multiple
                  sporting matches or through participation in one of our predictor games.</p>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingSix">
              <h2 class="mb-0 collapsed" data-toggle="collapse"
                  data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                <button class="btn btn-link" type="button">
                  FANTASY DRIBBLE & SPORT PREDICTOR GAME RULES
                </button>
              </h2>
            </div>
            <hr>
            <div id="collapseSix" class="collapse" aria-labelledby="headingSix"
                 data-parent="#accordionExample">
              <div class="card-body">
                <p>2.25) Each fantasy line-up must include real-life athletes, so that each entry into a Fantasy Dribble
                  event shall be made up of players drawn from a minimum of one real-life sporting matches.</p>
                <p>2.26) We strictly prohibit the winning of any Fantasy Dribble event based solely on the single
                  performance of an individual athlete.</p>
                <p>2.27) The Service will automatically prevent You from saving a line-up that is in violation of any of
                  these restrictions.</p>
                <p>2.28) There will be no trading of players, no extra moves and no replacing injured or benched players.
                </p>
                <p>2.29) Each Fantasy Dribble event requires selecting one striker, two midfielders, one defensive unit
                  (consisting of players listed as defensive players by the stats provider in a specific team) and a
                  goalkeeper.</p>
                <p>2.30) The player pool consists of players that the Statistics Provider has statistics for in that
                  particular league and determines to be eligible for the matches included in the Fantasy Dribble
                  event.</p>
                <p>2.31) Any players left off any squad by the Statistics Provider (“missing” players) will only be added
                  once the Statistics Provider recognizes and/or adds the new player and we shall not be liable in any
                  way for such player not being featured in any Fantasy Dribble event.</p>
                <p>2.32) Each Fantasy Dribble event specifies a date after which entries may not be added, edited, or
                  cancelled.</p>
                <p>2.33) Fantasy Dribble event results and winners will be based on the total points scored across each
                  entrant’s squad (scoring summarized below) during the duration of the Fantasy Dribble event.</p>
                <p>2.34) If a match that is part of a Fantasy Dribble event is rescheduled outside of the originally
                  scheduled beginning and end of the Fantasy Dribble event, players in those matches will earn zero
                  points.</p>
                <p>2.35) You can edit Your line-up at any point up to the start of a Fantasy Dribble event by clicking on
                  the edit option on the entry view. However, once a Fantasy Dribble event starts, your line-up will no
                  longer be editable.</p>
                <p>2.36) Users of the Service will have the ability to enter into Fantasy Dribble events as long as their
                  subscription to the content is active.</p>
                <p>2.37) We reserve the right to cancel any Fantasy Dribble event before it is scheduled to begin.</p>
                <p>2.38) We reserve the right to combine player pools should the number of users in a pool be too low for
                  reasonable levels of participation.</p>
                <p>2.39) Any existing in-bundle usage and any other loaded data in Your account will not be consumed until
                  the Service is depleted or expires. You can check Your bundle balance for the Service by dialling
                  *135#, and choosing option 1 – balances or via My Vodacom App.</p>
                <p>2.40) No data pro-ration will occur.</p>
                <p>2.41) If You use the applications outside of the Service, You will be charged as per Your existing
                  tariff plan. If You follow a link outside the Partner’s application and/or URL, normal data rates will
                  apply as per Your existing tariff plan.</p>
                <p>2.42) Your data bundle depletion will not occur for any banner advertising or in-stream advertising
                  that may be present within the Service.</p>
                <p>2.43) When making use of the Service, certain applications and/or URL may contain third party
                  advertisements, content, materials, and/or links to third party services and / or websites that are not
                  owned or controlled by Vodacom. Vodacom assumes no responsibility for, the content, privacy policies or
                  practices of any third-party websites or applications. In addition, Vodacom does not and cannot censor
                  or edit the content of any third-party website. When You visit third party websites, Vodacom encourages
                  You to read the terms and conditions and privacy policies of the other websites. By using the Service,
                  You expressly release Vodacom from all liability arising from Your use of any third-party website or
                  because of any third-party services.</p>
                <p>2.44) You cannot use the Services when You are roaming. Whilst roaming the use of an application and/or
                  URL forming part of the Service, will be charged at Your existing tariff plan.</p>
                <p>2.45) If You perform a price plan migration, whilst using You have an existing active Service, such
                  Service shall be carried over to the new price plan.</p>
                <p>2.46) If You perform a price plan upgrade, You will be able to add the Service to Your upgraded price
                  plan.</p>
                <p>2.47) Vodacom reserves the right to terminate or change the Service at any time and for whatsoever
                  reason provided the on-going subscription for the Service will not be affected.</p>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingEight">
              <h2 class="mb-0 collapsed" data-toggle="collapse"
                  data-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                <button class="btn btn-link" type="button">
                  OWNERSHIP
                </button>
              </h2>
            </div>
            <hr>
            <!---Ownership--->
            <div id="collapseEight" class="collapse" aria-labelledby="headingEight"
                 data-parent="#accordionExample">
              <div class="card-body">
                <p>2.48) All rights, title and interest in and to the Service including, but not limited to, any games,
                  titles, computer code, themes, objects, stories, dialogue, concepts, artwork, animations, sounds,
                  musical compositions, audio-visual effects, methods of operation, moral rights, documentation are owned
                  by Vodacom and its appointed partner. We reserve all rights, including, but not limited to, all
                  intellectual property rights or other proprietary rights, in connection with the Service.</p>
                <p>2.49) Vodacom and its appointed partner owns, has licensed, or otherwise has rights to use, or provide
                  all of the content that appears in the Service.</p>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingNine">
              <h2 class="mb-0 collapsed" data-toggle="collapse"
                  data-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                <button class="btn btn-link" type="button">
                  YOUR OBLIGATIONS AND ENTITLEMENTS
                </button>
              </h2>
            </div>
            <hr>
            <div id="collapseNine" class="collapse" aria-labelledby="headingNine"
                 data-parent="#accordionExample">
              <div class="card-body">
                <p>2.50) Vodacom and/or its appointed Partner reserves the right to determine what conduct it considers to
                  be in violation of the rules of use or otherwise outside the intent or spirit of these Terms and
                  Conditions or the Service itself. We reserve the right to act as a result, which may include, if
                  relevant, suspending the Service, terminating Your registration, and prohibiting You from using the
                  Service. Said suspension, termination and prohibition may occur with or without notice to You, and as a
                  result may involve the loss of any benefits, privileges or earned items associated with Your use of the
                  Service, and we are under no obligation to compensate You for any such losses or results.</p>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingTen">
              <h2 class="mb-0 collapsed" data-toggle="collapse"
                  data-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                <button class="btn btn-link" type="button">
                  LIMITATION OF LIABILITY
                </button>
              </h2>
            </div>
            <hr>
            <div id="collapseTen" class="collapse" aria-labelledby="headingTen"
                 data-parent="#accordionExample">
              <div class="card-body">
                <p>2.51) You agree that Your use of the Service shall be at Your sole risk. To the fullest extent
                  permitted by law, we and our officers, directors, employees, and agents disclaim all warranties,
                  express or implied, in connection with the services and Your use thereof. We make no warranties or
                  representations about the accuracy or completeness of the Service’s content or the content of any
                  websites or services linked to these services and assume no liability or responsibility for any (i)
                  errors, mistakes, or inaccuracies of content; (ii) personal injury or property damage of any nature
                  whatsoever resulting from Your access to and use of the Service; (iii) any unauthorized access to or
                  use of our servers and/or any and all personal information and/or financial information stored
                  therein; (iv) any interruption or cessation of transmission to or from the Service; (v) any bugs,
                  viruses, trojan horses or the like which may be transmitted to or through the Service by any third
                  party; or (vi) any errors or omissions in any content or for any loss or damage of any kind incurred
                  as a result of the use of any content posted, emailed, transmitted, or otherwise made available via
                  the Service. We do not warrant, endorse, guarantee, or assume responsibility for any product or
                  Service advertised or offered by a third party through the Service or any hyperlinked website or
                  featured in any banner or other advertising, and we will not be a party to or in any way be responsible
                  for monitoring any transaction between You and third-party providers of products or services.</p>
                <p>2.52) To the extent permitted by applicable law, in no event shall we or our subsidiaries and
                  affiliates, and their respective officers, directors, owners, agents, employees, representatives and
                  licensors be liable for any special, incidental, indirect, consequential, punitive or exemplary losses
                  or damages whatsoever or for loss of profits (including, without limitation, damages for loss of
                  revenue, loss of data, failure to realize expected savings, interruption of activities, or any other
                  pecuniary or economic loss) and whether arising from breach of contract, damages (including
                  negligence), strict liability or otherwise, arising out of the use of or inability to use the Service
                  or its content, or any product or service described or provided through the Service.</p>
                <p>2.53) Save to the extent permitted by law, You agree to indemnify, defend and hold harmless Vodacom
                  from and against any and all claims, demands, actions, liability, losses, costs and expenses
                  (including legal fees and expenses) arising from or related to: (i) any use or alleged use of the
                  Service by any other person, whether or not authorized by You; (ii) Your breach of these Terms and
                  Conditions, including any breach of Your representations and warranties herein; and (iii) Your
                  violation of any law or (iv) Your use of or inability to use the Service, the contents, any hyperlinked
                  website, and any of the products and services made available on the Service thereof.</p>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingEleven">
              <h2 class="mb-0 collapsed" data-toggle="collapse"
                  data-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven">
                <button class="btn btn-link" type="button">
                  {{ cashCompetitionMode ? 'FANTASY DRIBBLE MINI APP – CASH COMPETITION' : 'FANTASY DRIBBLE SUBSCRIPTION AND REWARD PROMOTION' }}
                </button>
              </h2>
            </div>
            <hr>
            <div id="collapseEleven" class="collapse" aria-labelledby="headingEleven"
                 data-parent="#accordionExample">
              <div class="card-body" v-if="cashCompetitionMode">
                <p><strong>1 Introduction:</strong></p>
                <p>1.1) Vodacom (Pty) Ltd (“Vodacom”) and Fanclash (Pty) Ltd (“Partner”) are running a Competition where participants stand a chance of winning their share of R5 000.00 (five thousand Rand) in cash by downloading the VodaPay app and playing the Fantasy Dribble MiniApp free predictor game (the “Competition”).</p>
                <p><strong>IMPORTANT PROVISION: ACCEPTANCE OF THESE TERMS AND CONDITIONS</strong></p>
                <p>PLEASE READ THESE TERMS AND CONDITIONS AND THE <a href="https://www.vodacom.co.za/vodacom/terms/privacy-policy" target="_blank"><strong>PRIVACY POLICY</strong></a> CAREFULLY BEFORE PARTICIPATING IN THIS COMPETITION. BY ENTERING THE COMPETITION, YOU ARE AGREEING TO BE BOUND BY THESE TERMS AND CONDITIONS. IF YOU DO NOT AGREE, PLEASE DO NOT ENTER THE COMPETITION OR SUBMIT ANY INFORMATION IN THIS REGARD. WE RESERVE THE RIGHT, AT ANY TIME, TO MODIFY AND UPDATE THESE TERMS AND CONDITIONS FROM TIME TO TIME BY POSTING SUCH UPDATED TERMS AND CONDITIONS ON THE VODACOM WEBSITE. ANY SUCH UPDATES SHALL APPLY TO YOU AND YOUR ENTRY INTO THE COMPETITION AND YOU SHALL BE DEEMED TO HAVE ACCEPTED SUCH CHANGES.</p>
                <p><strong>ALL PARTICIPANTS TO THE COMPETITION AGREE TO BE BOUND BY THE FOLLOWING TERMS AND CONDITIONS:</strong></p>
                <p><strong>2 Duration:</strong></p>
                <p>2.1) This Competition shall commence on 00h01 on 01 August 2026 to 23h59 on 30 June 2027 (the “End Date”) (“the Competition Period”).</p>
                <p>2.2) The duration of the Competition may be extended or curtailed at the discretion of Vodacom.</p>
                <p><strong>3 Prizes:</strong></p>
                <p>3.1) 5 (Five) participants to the Competition stand a chance to win R1 000.00 (one thousand Rand) each.</p>
                <p>3.2) The total value of the Prize is R5 000.00 (five thousand Rand) (“the Prize”).</p>
                <p><strong>4 Eligibility:</strong></p>
                <p>4.1) Only entries received during the Competition period will qualify to enter the Competition.</p>
                <p>4.2) The following requirements must be complied with during the Competition period in order to qualify for entry into the Competition:</p>
                <p><span class="pl-3">4.2.1) be a natural person;</span></p>
                <p><span class="pl-3">4.2.2) be at least 18 (eighteen) years and older;</span></p>
                <p><span class="pl-3">4.2.3) be a Vodacom prepaid, hybrid or post-paid subscriber during the Competition Period;</span></p>
                <p><span class="pl-3">4.2.4) reside in South Africa and be in possession of a valid South African identify document or South African permanent residence permit or a South African temporary residence permit valid for a period exceeding 3 (three) months which permits shall be valid as at the End Date;</span></p>
                <p><span class="pl-3">4.2.5) use a SIM card that has been RICA registered;</span></p>
                <p><span class="pl-3">4.2.6) download the VodaPay application on Google Play Store, Apple App Store or Huawei AppGallery; and</span></p>
                <p><span class="pl-3">4.2.7) play the Fantasy Dribble free predicator MiniApp game and start earning points by making weekly soccer predictions. Each point constitutes an entry into the lucky draw. (e.g. if a subscriber has earned 500 points in the Competition, they will have 500 entries into the lucky draw for the prize at the end of the Competition period). The allocation of points is indicated in table 1 below:</span></p>
                <p class="row justify-content-center mb-0"><strong>Table 1</strong></p>
                <div class="row justify-content-center">
                  <table>
                    <thead>
                    <tr>
                      <td><strong>Action</strong></td>
                      <td><strong>Points Awarded Per Match</strong></td>
                    </tr>
                    </thead>
                    <tr>
                      <td>Home Team Score Correct</td>
                      <td>6 Points</td>
                    </tr>
                    <tr>
                      <td>Away Team Score Correct</td>
                      <td>6 Points</td>
                    </tr>
                    <tr>
                      <td>Final Score Result</td>
                      <td>10 Points</td>
                    </tr>
                    <tr>
                      <td>All Predictions Correct</td>
                      <td>10 Points</td>
                    </tr>
                  </table>
                </div>
                <p>4.3) Once or if all the requirements of paragraphs 4.2.1 to 4.2.7 are met, entry into the Competition will be automatic.</p>
                <p>4.4) Employees, directors and agents of Vodacom and the Partner (where applicable) all participating stores, their immediate families, life partners, business partners and associates and any person directly involved with the sponsoring, devising, production, management or marketing of this Competition are not eligible to enter this Competition.</p>
                <p>4.5) In the event that the registered user of the SIM Card or Vodacom account (i.e., the participant in the Competition) is not the person that is responsible for payment of the Vodacom account/ charges on the Vodacom account, then the Prize will be awarded to the person that is responsible for payment of the Vodacom account.</p>
                <p>4.6) Standard data costs apply as per the user’s Service Provider and existing price plan for data usage. Vodacom shall not be liable for any costs incurred by the winners for claiming any Prizes, where applicable.</p>
                <p><strong>5 Prize draw</strong></p>
                <p>5.1) Winners will be randomly selected on 5 July 2027 from all eligible entries who meet all the requirements set out in clause 4 above.</p>
                <p><strong>6 Winner Validation</strong></p>
                <p>6.1) All the information provided or related to this Competition shall be managed, captured and approved by Vodacom and/or the Partner (where applicable).</p>
                <p>6.2) Vodacom and/or the Partner (where applicable) will use reasonable efforts to contact the winners telephonically on the MSISDN used by the participant to enter to the Competition ("Registered MSISDN").</p>
                <p>6.3) The claim for any Prize will be subject to security and validation, and Vodacom reserves the right to withhold any Prize until it is satisfied that the claim by a particular winner is valid. The selected winners must be able to identify themselves, in a manner determined by Vodacom, as the qualifying participants to the Competition and are required to comply with the validation procedure, determined by Vodacom, to claim any Prizes, failing which such winner will forfeit the Prize and the Prize will be awarded to the next selected qualifying participant.</p>
                <p>6.4) Vodacom and/or the Partner (where applicable) shall attempt to contact the winners for a period of 05 (five) working days after their names have been drawn and verified as winners. The winners will be contacted during normal working hours, between 09:00 to 16:00. Winners will be advised of arrangements in respect of Prizes at the time of contacting the selected winners. Should a participant not be available on the Registered MSISDN during the timeframe stipulated above or rejects, forfeits or declines acceptance of the Prize, that person's right to the Prize will be deemed to have been waived and the Prize will be forfeited. Vodacom reserves the right to then award the Prize to the next randomly drawn participant. The winners will be contacted within 7 (seven) working days after each draw date.</p>
                <p>6.5) In the event that Vodacom requires certain documentation to be submitted by a particular winner and same has not been received at the agreed cut-off date communicated to the winner, or no effort is made on the part of any of the winners to make special arrangements to meet the deadline set by Vodacom, such Prize will be forfeited. Vodacom then reserves the right to award the Prize to the finalist that is next in line.</p>
                <p>6.6) Vodacom and/or the Partner (where applicable) shall request the winners’ consent in writing to their image and/or likeness being used and published by Vodacom in connection with the Competition for a period of 12 (twelve) months after they have been announced as winners. The winners may decline the use of their image and/or likeness by Vodacom.</p>
                <p><strong>7 Prize Delivery</strong></p>
                <p>7.1) All Prizes will be deposited directly into the winner’s bank account. It is mandatory for the winner to submit a bank account confirmation letter.</p>
                <p>7.2) If a winner cannot accept a Prize for any reason whatsoever, the Prize will be awarded to the next selected participant.</p>
                <p>7.3) All risks and ownership of the Prizes shall pass to the winners on transfer/delivery thereof and hence all of Vodacom’s obligations regarding the Competition as well as in regard to the Prizes shall terminate.</p>
                <p><strong>8 Personal information</strong></p>
                <p>8.1) User data, including personal information collected via the Competition will not be used for any other purpose than for execution of the Competition and will be processed in line with the Vodacom’s <a href="https://www.vodacom.co.za/vodacom/privacy-policy/terms?icmp=Home/Footer/PrivacyPolicy" target="_blank"><strong>Privacy Statement</strong></a> which is incorporated into these terms and conditions. The Privacy Statement sets out how amongst other things Vodacom collects, use and shares subscribers personal information and how it protects subscriber’s privacy when processing their information.</p>
                <p>8.2) By continuing, a subscriber confirms that the Vodacom Privacy Statement has been read and understood. The latest Privacy Statement can be found on the Vodacom website at <a href="https://www.vodacom.co.za/vodacom/privacy-policy/terms?icmp=Home/Footer/PrivacyPolicy" target="_blank">https://www.vodacom.co.za/vodacom/privacy-policy/terms?icmp=Home/Footer/PrivacyPolicy</a>.</p>
                <p><strong>9 General</strong></p>
                <p>9.1) Participants may obtain a copy of the competition rules on the URL: <a href="https://fantasydribble.com" target="_blank">https://fantasydribble.com</a>.</p>
                <p>9.2) Nothing in these Terms and Conditions is intended to, or must be understood to, unlawfully restrict, limit or avoid any rights or obligations, as the case may be, created for either the participant or Vodacom in terms of the Consumer Protection Act, 68 of 2008 ("CPA").</p>
                <p>9.3) The Prize is not transferable and is not exchangeable for another Prize and cannot be sold.</p>
                <p>9.4) The decision of Vodacom in respect of disputes arising out of this Competition shall be dealt with by Vodacom in terms of these Terms and Conditions. The decision of Vodacom in this regard shall be final and binding on the Parties and no correspondence will be entered into.</p>
                <p>9.5) Winners are only entitled to win 1 (one) Prize each.</p>
                <p>9.6) In the event of a dispute with regard to any aspect of the Competition and/or the Terms and Conditions, Vodacom’s decision will be final, and binding and no correspondence will be entered into.</p>
                <p>9.7) Vodacom and/or the Partner may refuse to award a Prize if entry procedures or these Terms and Conditions have not been adhered to or if it detects any irregularities or fraudulent practices. Vodacom is entitled in its entire discretion to reject any participant for any reason and will not be obliged to notify participants that they have not been successful.</p>
                <p>9.8) Vodacom and/or the Partner and/or any other person or party associated with the Competition, their associated companies, agents, contractors and sponsors and any of its personnel involved in the Competition, shall not be liable whatsoever for any loss or damage incurred or suffered (including but not limited to direct or indirect or consequential loss), death or personal injury suffered or sustained arising from either the participant entering the Competition or from it claiming a Prize.</p>
                <p>9.9) Vodacom is not liable for any technical failures affecting participation and / or Prize redemption process of the Competition. In addition, neither Vodacom nor its agents shall be responsible for any loss or misdirected entries, including entries that were not received due to any failure of hardware, software, or other computer or technical systems affecting participating in and/or the Prize redemption process of the Competition.</p>
                <p>9.10) Vodacom, its directors, employees, agents, and distributors, are not responsible for any misrepresentation (whether written or verbal) in respect of any Prize nor in respect of any warranties, guarantees or undertakings given by any person other than Vodacom itself.</p>
                <p>9.11) If Vodacom elects in its sole and absolute discretion or is required by law to alter, vary or cancel any aspect of the Competition, it will have the right to terminate the Competition being offered, with immediate effect and upon written notice being published on the Vodacom website. In such event all participants hereby waive any rights which they may have against Vodacom and its associated companies, agents, contractors and/or sponsors.</p>
                <p>9.12) All information relating to the Competition which is published on any marketing material will form part of these Terms and Conditions. In the event of any conflict between such marketing material and these Terms and Conditions, these Terms and Conditions shall prevail.</p>
                <p>9.13) The Competition is also subject to, and must be read in conjunction with, Vodacom’s existing terms and conditions applicable to its website and mobile site respectively, which terms and conditions are available on the Vodacom website.</p>
              </div>
              <div class="card-body" v-else>
                <p><strong>1 Introduction:</strong></p>
                <p>1.1) Vodacom (Pty) Ltd ("Vodacom") and Fanclash South Africa (Pty) Ltd ("Partner") are running a Promotion in which participants stand a chance of winning their share in R220 000.00 (two hundred and twenty thousand Rand) worth of reward coupons by subscribing to Fantasy Dribble (the "Service") for only R5.00 (five Rand) per day (the "Promotion").</p>
                <p><strong>IMPORTANT PROVISION: ACCEPTANCE OF THESE TERMS AND CONDITIONS</strong></p>
                <p>PLEASE READ THESE TERMS AND CONDITIONS AND THE PRIVACY POLICY CAREFULLY BEFORE PARTICIPATING IN THIS COMPETITION. BY ENTERING THE COMPETITION, YOU ARE AGREEING TO BE BOUND BY THESE TERMS AND CONDITIONS. IF YOU DO NOT AGREE, PLEASE DO NOT ENTER THE COMPETITION OR SUBMIT ANY INFORMATION IN THIS REGARD. WE RESERVE THE RIGHT, AT ANY TIME, TO MODIFY AND UPDATE THESE TERMS AND CONDITIONS FROM TIME TO TIME BY POSTING SUCH UPDATED TERMS AND CONDITIONS ON THE VODACOM WEBSITE. ANY SUCH UPDATES SHALL APPLY TO YOU AND YOUR ENTRY INTO THE COMPETITION AND YOU SHALL BE DEEMED TO HAVE ACCEPTED SUCH CHANGES.</p>
                <p><strong>ALL PARTICIPANTS TO THE PROMOTION AGREE TO BE BOUND BY THE FOLLOWING TERMS AND CONDITIONS:</strong></p>
                <p><strong>2 Duration:</strong></p>
                <p>2.1) This Promotion shall commence on 00h01 on 01 April 2026 to 23h59 on 31 March 2027 (the "End Date") ("the Promotion Period").</p>
                <p>2.2) The duration of the Promotion Period may be extended or curtailed at the discretion of Vodacom.</p>
                <p><strong>3 Rewards:</strong></p>
                <p>3.1) For each subscription to the Service, the participants stand a chance to receive a R5.00 (five Rand) value reward coupon ("Reward Coupon") to be redeemed on the Fantasy Dribble coupon store. The Reward Coupon can be exchanged for a Shoprite &amp; Checkers, KFC, Pick 'n Pay or PEP coupon ("Coupons") or Vodacom airtime ("Airtime") ("The Reward").</p>
                <p>3.2) The Reward Coupon must be redeemed within 7 (seven) days of being awarded, failing which the Reward will lapse. Once redeemed, participants will have an additional 30 (thirty) days to claim a specific coupon value from the coupon store.</p>
                <p>3.3) The participants are bound by the coupon usage terms and conditions found on the following websites:</p>
                <p><span class="pl-3">3.3.1) Shoprite &amp; Checkers: https://tickets.computicket.com/event/shoprite_group_virtual_grocery_vouchers/7145292/7165772/107235;</span></p>
                <p><span class="pl-3">3.3.2) KFC: https://order.kfc.co.za/terms-conditions;</span></p>
                <p><span class="pl-3">3.3.3) Pick 'n Pay: https://www.pnp.co.za/ols-tncs;</span></p>
                <p><span class="pl-3">3.3.4) PEP: https://www.pepstores.com/pages/term-conditions; and</span></p>
                <p><span class="pl-3">3.3.5) Vodacom: https://www.vodacom.co.za/shopping/search-products/airtime.</span></p>
                <p>3.4) The total value of the Reward is R220 000.00 (two hundred and twenty thousand Rand).</p>
                <p><strong>4 Eligibility:</strong></p>
                <p>4.1) Only entries received during the Promotion Period will qualify to enter the Promotion.</p>
                <p>4.2) The following requirements must be complied with during the Promotion Period in order to qualify for entry into the Promotion:</p>
                <p><span class="pl-3">4.2.1) be a natural person;</span></p>
                <p><span class="pl-3">4.2.2) be at least 18 years and older;</span></p>
                <p><span class="pl-3">4.2.3) be a Vodacom prepaid, hybrid or post-paid subscriber during the Promotion Period;</span></p>
                <p><span class="pl-3">4.2.4) reside in South Africa and be in possession of a valid South African identify document or South African permanent residence permit or a South African temporary residence permit valid for a period exceeding 3 (three) months which permits shall be valid as at the End Date;</span></p>
                <p><span class="pl-3">4.2.5) use a SIM card that has been RICA registered; and</span></p>
                <p><span class="pl-3">4.2.6) subscribe to the Service for R5.00 (five Rand) per day, by:</span></p>
                <p><span class="pl-5">4.2.6.1) dialing USSD *130*2586#; or</span></p>
                <p><span class="pl-5">4.2.6.2) visiting web https://fantasydribble.com.</span></p>
                <p>4.3) Once or if all the requirements of paragraphs 4.2.1 to 4.2.6 are met, entry into the Promotion will be automatic.</p>
                <p>4.4) Employees, directors and agents of Vodacom and the Partner (where applicable) all participating stores, their immediate families, life partners, business partners and associates and any person directly involved with the sponsoring, devising, production, management or marketing of this Promotion are not eligible to enter this Promotion.</p>
                <p>4.5) In the event that the registered user of the SIM Card or Vodacom account (i.e., the participant in the Promotion) is not the person that is responsible for payment of the Vodacom account/ charges on the Vodacom account, then the Reward will be awarded to the person that is responsible for payment of the Vodacom account.</p>
                <p>4.6) Standard data costs apply as per the user's Service Provider and existing price plan for data usage. Vodacom shall not be liable for any costs incurred by the participants for claiming any Rewards, where applicable.</p>
                <p><strong>5 Participant Validation</strong></p>
                <p>5.1) All the information provided or related to this Promotion shall be managed, captured and approved by Vodacom and/or the Partner (where applicable).</p>
                <p>5.2) Vodacom and/or the Partner (where applicable) will use reasonable efforts to contact the participants via SMS on the MSISDN used by the participant to subscribe to the Service ("Registered MSISDN").</p>
                <p>5.3) The claim for any Reward Coupon will be subject to security, validation, availability, and Vodacom reserves the right to withhold any Reward Coupon until it is satisfied that the claim by a particular participant is valid. The selected participants must be able to identify themselves, in a manner determined by Vodacom, as the qualifying participants to the Promotion and are required to comply with the validation procedure, determined by Vodacom, to claim any coupons failing which such participant will forfeit the Reward and the Reward will be awarded to the next selected qualifying participant.</p>
                <p>5.4) Vodacom and/or the Partner (where applicable) shall request the participants' consent in writing to their image and/or likeness being used and published by Vodacom in connection with the Promotion for a period of 12 (twelve) months after they have been announced as participants. The participants may decline the use of their image and/or likeness by Vodacom.</p>
                <p><strong>6 Coupon Delivery</strong></p>
                <p>6.1) All Rewards will be sent to the participant's Registered MSISDN. Participants must access the Fantasy Dribble service on: https://fantasydribble.com or by dialling *130*2586# to claim the Reward Coupon and to receive a coupon PIN. The recipient will receive an SMS containing the coupon store URL wherein they will be able to redeem the Reward Coupon.</p>
                <p>6.2) The Airtime Rewards will be deposited directly into the participants' Registered MSISDN in the form of a 10 (ten) to 16 (sixteen) digit PIN. The recipient will receive an SMS notification. To redeem the Airtime the participants must dial *130*888*PIN# or *136*01*PIN# then follow the prompts.</p>
                <p>6.3) All risks and ownership of the Rewards shall pass to the participants on transfer/delivery thereof and hence all of Vodacom's obligations regarding the Promotion as well as in regard to the Rewards shall terminate.</p>
                <p><strong>7 Personal information</strong></p>
                <p>7.1) User data, including personal information collected via the Promotion will not be used for any other purpose than for execution of the Promotion and will be processed in line with the Vodacom's Privacy Statement which is incorporated into these terms and conditions. The Privacy Statement sets out how amongst other things Vodacom collects, use and shares subscribers personal information and how it protects subscriber's privacy when processing their information.</p>
                <p>7.2) By continuing, a subscriber confirms that the Vodacom Privacy Statement has been read and understood. The latest Privacy Statement can be found on the Vodacom website at https://www.vodacom.co.za/vodacom/privacy-policy/terms?icmp=Home/Footer/PrivacyPolicy.</p>
                <p><strong>8 General</strong></p>
                <p>8.1) Participants may obtain a copy of the competition rules on the URL: https://fantasydribble.com/terms-and-conditions.</p>
                <p>8.2) Nothing in these Terms and Conditions is intended to, or must be understood to, unlawfully restrict, limit or avoid any rights or obligations, as the case may be, created for either the participant or Vodacom in terms of the Consumer Protection Act, 68 of 2008 ("CPA").</p>
                <p>8.3) The Reward is not transferable and is not exchangeable for another Reward or cash and cannot be sold.</p>
                <p>8.4) The decision of Vodacom in respect of disputes arising out of this Promotion shall be dealt with by Vodacom in terms of these Terms and Conditions. The decision of Vodacom in this regard shall be final and binding on the Parties and no correspondence will be entered into.</p>
                <p>8.5) In the event of a dispute with regard to any aspect of the Promotion and/or the Terms and Conditions, Vodacom's decision will be final, and binding and no correspondence will be entered into.</p>
                <p>8.6) Vodacom and/or the Partner may refuse to award a Reward if entry procedures or these Terms and Conditions have not been adhered to or if it detects any irregularities or fraudulent practices. Vodacom is entitled in its entire discretion to reject any participant for any reason and will not be obliged to notify participants that they have not been successful.</p>
                <p>8.7) Vodacom and/or the Partner and/or any other person or party associated with the Promotion, their associated companies, agents, contractors and sponsors and any of its personnel involved in the Promotion, shall not be liable whatsoever for any loss or damage incurred or suffered (including but not limited to direct or indirect or consequential loss), death or personal injury suffered or sustained arising from either the participant entering the Promotion or from it claiming a Reward.</p>
                <p>8.8) Vodacom is not liable for any technical failures affecting participation and / or Reward redemption process of the Promotion. In addition, neither Vodacom nor its agents shall be responsible for any loss or misdirected entries, including entries that were not received due to any failure of hardware, software, or other computer or technical systems affecting participating in and/or the Reward redemption process of the Promotion.</p>
                <p>8.9) Vodacom, its directors, employees, agents, and distributors, are not responsible for any misrepresentation (whether written or verbal) in respect of any Reward nor in respect of any warranties, guarantees or undertakings given by any person other than Vodacom itself.</p>
                <p>8.10) If Vodacom elects in its sole and absolute discretion or is required by law to alter, vary or cancel any aspect of the Promotion, it will have the right to terminate the Promotion being offered, with immediate effect and upon written notice being published on the Vodacom website. In such event all participants hereby waive any rights which they may have against Vodacom and its associated companies, agents, contractors and/or sponsors.</p>
                <p>8.11) All information relating to the Promotion which is published on any marketing material will form part of these Terms and Conditions. In the event of any conflict between such marketing material and these Terms and Conditions, these Terms and Conditions shall prevail.</p>
                <p>8.12) The Promotion is also subject to, and must be read in conjunction with, Vodacom's existing terms and conditions applicable to its website and mobile site respectively, which terms and conditions are available on the Vodacom website.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import GoBack from "@/components/goBack";

export default {
  name: "App",
  components: {GoBack},
  data: function () {
    return {
      cashCompetitionMode: true,
      miniAppModel: {
        miniAppMode: undefined,
        vodapayUserId: undefined,
        fantasyToken: undefined
      },
      backgroundImageUrl: window.innerWidth > 768 ? 'vodacom-trivia-soccer-bg-desktop' : 'vodacom-trivia-soccer-bg-mobile'
    }
  },
  methods: {
    setBackgroundUrl() {
      this.backgroundImageUrl = window.innerWidth > 768 ? 'vodacom-trivia-soccer-bg-desktop' : 'vodacom-trivia-soccer-bg-mobile'
    },
    getQueryParams() {
      let queryString = window.location.search;
      return new URLSearchParams(queryString);
    },
    setMiniAppModel(urlParams) {
      const miniApp = urlParams.get('miniAppMode');
      const vodapayUserId = urlParams.get('vodapayUserId');
      const fantasyToken = urlParams.get('fantasyToken');
      this.miniAppModel.vodapayUserId = vodapayUserId ?? this.miniAppModel.vodapayUserId;
      this.miniAppModel.miniAppMode = miniApp ?? this.miniAppModel.miniAppMode;
      this.miniAppModel.fantasyToken = fantasyToken ?? this.miniAppModel.fantasyToken;
    }
  },
  mounted() {
    const collapseShow = $(".collapse.show");
    collapseShow.each(function () {
      $(this).prev(".card-header").find(".fa").addClass("fa-minus").removeClass("fa-plus");
    });

    const collapse = $(".collapse");
    // Toggle plus minus icon on show hide of collapse element
    collapse.on('show.bs.collapse', function () {
      $(this).prev(".card-header").find(".fa").removeClass("fa-plus").addClass("fa-minus");
    }).on('hide.bs.collapse', function () {
      $(this).prev(".card-header").find(".fa").removeClass("fa-minus").addClass("fa-plus");
    });

    window.addEventListener("resize", this.setBackgroundUrl.bind(this));
  },
  beforeMount() {
    const urlParams = this.getQueryParams();
    this.setMiniAppModel(urlParams);

  }
}
</script>

<style lang="scss">
.bullet-point-paragraph {
  display: flex;
  flex-direction: column;
}

GoBack {
  display: flex;
  cursor: pointer;
}

.paragraph-container {
  display: flex;
  margin-bottom: 10px;
}

.card-header > h2:after {
  font-family: FontAwesome;
  position: absolute;
  right: 0;
  content: "\f068";
  color: red;
  font-size: 1.5rem;
  top: 50%;
  transform: translateY(-50%);
}

.card-header > h2.collapsed:after {
  /* float: right !important; This was the problem, so it's removed */
  content: "\f067";
}

.card-header > h2:hover,
.card-header > h2:active,
.card-header > h2:focus {
  text-decoration: none;
}

#app {
  height: 100vh;
  width: 100vw;
}

#nav {
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #4a4d4e;
    }
  }
}

p {
  //display: flex;
  /*margin-bottom: 0 !important;*/
}

h5 {
  color: #fff !important
}

.loading-wrapper {
  z-index: 10;
  position: fixed;
  top: 10vh;
  left: 0;
  width: 110vw;
  height: 90vh;
  background: rgba(255, 255, 255, 0.7);
}

.navbar {
  z-index: 2;
  width: 100vw;
  height: 10vh;
  position: fixed;
  top: 0;
  left: 0;
  background: #3b3b3b;
}

.vodafone-icon {
  height: 80%;
}

.navbar-text {
  font-family: 'Helvetica', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #FFFFFF;
  font-size: 1.6rem;
}

.background-img {
  background-repeat: no-repeat;
  top: 0;
  width: 100vw;
  height: 100vh;
  position: fixed;
}

.main-heading {
  padding: 0 1rem;
}

.sub-heading {
  font-size: 1.5rem;
  text-align: center;
}

hr {
  height: 2px;
  background-color: #FFFFFF;
  border: none;
  width: 100%;
}

.card {
  background: none;
  border: none;
}

.card-header {
  padding: 0 0;
}

.card-header:hover {
  cursor: pointer;
}

.btn-link {
  padding: 0 0;
  background: none;
  color: #FFFFFF;
  font-size: 0.8rem;
  font-weight: bold;
  text-decoration: none;
  text-align: left;
  padding-right: 2rem;
  width: 100%;
}

h2 {
  display: flex;
  align-items: center;
  position: relative;
}

.fa {
  position: absolute;
  right: 0;
  color: red;
  font-size: 0.8rem;
}

table {
  border: solid 1px #FFFFFF;
  border-radius: 6px;
  padding-right: 1rem;
  padding-left: 1rem;
  margin: 0.5rem 0 0.5rem 0;
}

thead {
  font-weight: bold;
}

go-back {
  background-color: #DA1B19;
  color: white;
}

td {
  border: solid 1px #FFFFFF;
  padding-right: 1rem;
  padding-left: 1rem;
}

@media (min-width: 768px) {
  .btn-link {
    font-size: 1.1rem;
  }
}

@media (min-width: 1200px) {
  .btn-link {
    font-size: 1.5rem;
  }
}
</style>